import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("codira_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (path) => `${BACKEND}${path}`;
